import React from "react";
import styled from "styled-components";

const InputSolid = styled.input`
  display: block;
  width: 100%;
  border-radius: 8px;
  padding: 16px 24px;
  border: 1px solid #F3F3F3;
  font-size: 24px;
  line-height: 34px;
  background-color: #F3F3F3;
  border-radius: 15px;

  ::-webkit-input-placeholder {
    color: #07131e;
    font-weight: 500;
    font-size: 24px;
  } 

  :-ms-input-placeholder {
    color: #07131e;
    font-weight: 500;
    font-size: 24px;
  }

  ::placeholder {
    color: #07131e;
    font-weight: 500;
    font-size: 24px;
  }

  :disabled{
    opacity:0.8;
    background: #efefef;
  }
`;

const Input = ({
  type = "text",
  placeholder,
  css = "",
  ...rest
}) => {
  return <InputSolid
      width="100%"
      type={type}
      color="text"
      placeholder={placeholder}
      {...rest}
    />
};

export default Input;
